export const exportarDetalleAExcel = (
  detalleEmpresaSeleccionada: any[],
  detalleEmpresa: string,
  detalleSemana: string
) => {
  if (!detalleEmpresaSeleccionada || detalleEmpresaSeleccionada.length === 0) {
    alert("No hay datos para exportar.");
    return;
  }

  let csv = "Proveedor,Moneda,Monto Factura,Pagado\n";

  detalleEmpresaSeleccionada.forEach(item => {
    const proveedor = item.CardName || "";
    const moneda = item.MONEDA || "";
    const monto = item["MONTO FACTURA"] != null ? item["MONTO FACTURA"].toString().replace(/\./g, "") : "0";
    const pagado = item.PAGADO != null ? item.PAGADO.toString().replace(/\./g, "") : "0";

    csv += `"${proveedor}","${moneda}","${monto}","${pagado}"\n`;
  });

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute(
    "download",
    `detalle_${detalleEmpresa}_${detalleSemana}.csv`
  );
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
